
import { useSelector } from 'react-redux';
import { useCookie } from '../utils/cookie';
import { createContext, useContext, useState } from 'react';
import Loading from '../components/Loading';

const AuthContext = createContext();
const superadmin_emails = ["fard@licensechecking.com", "chintan@licensechecking.com"]

export const AuthProvider = ({ children }) => {
    const { set, get, remove } = useCookie();
    const [pageLoading, setPageLoading] = useState(false)
    const [auth, setAuth] = useState(() => {
        const token = get('auth_token');
        const user = get('user');
        var role = superadmin_emails.includes(user?.email) ? "super_admin" : user?.role
        if (token) {
            global.auth_token = token
            global.role = role
        }
        return token ? {
            token,
            role: role,
            userDetails: user,
            isAuthenticated: true,
        } : {
            isAuthenticated: false
        };
    });
    const { loading } = useSelector((state) => state.base);

    const login = (token, userDetails) => {
        set('auth_token', token);
        var role = superadmin_emails.includes(userDetails?.email) ? "super_admin" : userDetails?.role
        global.auth_token = token
        global.role = role
        setTimeout(() => {
            setAuth({
                token,
                userDetails,
                isAuthenticated: true,
                role: role
            });
        }, 100);
    };


    const logout = () => {
        remove('user');
        remove('auth_token');
        global.role = null
        global.auth_token = null
        setAuth({ isAuthenticated: false });
    };

    return (
        <AuthContext.Provider key="auth-provider" value={{ auth, login, logout, pageLoading, setPageLoading }}>
            {children}
            <Loading loading={loading} />
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);